/* RENATO — theme behaviours.
   No dependencies, no build step. Everything here is progressive: the markup is
   usable with this file blocked.

   Class names are FLAT to match renato.css. A BEM class here does not throw —
   querySelector just returns null and the behaviour quietly does nothing.
*/
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ------------------------------------------------------------------ header
     Transparent over the hero, solid cream past 80px of scroll. The threshold
     is the spec's, not a guess at the header's own height.

     THE TARGET IS STILL .rn-header, AND ON PURPOSE. The stickiness moved out to
     the section wrapper (.rn-headershell) because a sticky element inside a
     wrapper its own height has nowhere to stick — but the painted surface did
     not move with it. .rn-header is what carries the background, the hairline
     and the 400ms fade between the two states; the shell is transparent and has
     no transition. Retargeting this to the shell would put a colour on a box
     with no rule to fade it, and the transparent-over-the-hero state would go
     with it. Two elements, two jobs. */
  function header() {
    var el = document.querySelector('.rn-header');
    if (!el) return;

    // A page whose first section is not a full-bleed hero has nothing for a
    // transparent header to sit on, so it starts solid and stays solid.
    if (el.hasAttribute('data-rn-header-always-solid')) {
      el.classList.add('rn-header-solid');
      return;
    }

    var solid = null;
    function update() {
      var next = window.scrollY > 80;
      if (next === solid) return;          // don't touch the class list on every frame
      solid = next;
      el.classList.toggle('rn-header-solid', next);
    }

    update();
    window.addEventListener('scroll', function () {
      window.requestAnimationFrame(update);
    }, { passive: true });
  }

  /* ---------------------------------------------------------- announcement
     Three promises will not fit on one phone line. Above 768px they sit in a
     row; below it they rotate in place.

     The interval doubles under prefers-reduced-motion rather than stopping,
     because stopping would hide two of the three promises permanently. With
     this script blocked nothing is hidden and all three wrap. */
  function announcement() {
    var bar = document.querySelector('[data-rn-rotate]');
    if (!bar) return;

    var items = bar.querySelectorAll('[data-rn-rotate-item]');
    if (items.length < 2) return;

    var wide = window.matchMedia('(min-width: 768px)');
    var seconds = parseFloat(bar.getAttribute('data-rn-rotate')) || 5;
    var timer = null;
    var i = 0;

    function showAll() {
      Array.prototype.forEach.call(items, function (it) {
        it.classList.remove('rn-promise-hidden');
      });
    }

    function step() {
      Array.prototype.forEach.call(items, function (it, n) {
        it.classList.toggle('rn-promise-hidden', n !== i);
      });
      i = (i + 1) % items.length;
    }

    function sync() {
      if (timer) { clearInterval(timer); timer = null; }
      if (wide.matches) { showAll(); return; }

      var ms = seconds * 1000 * (reduced.matches ? 2 : 1);
      i = 0;
      step();
      timer = setInterval(step, ms);
    }

    sync();
    // addEventListener on a MediaQueryList is not in older Safari; addListener is.
    if (wide.addEventListener) {
      wide.addEventListener('change', sync);
      reduced.addEventListener('change', sync);
    } else if (wide.addListener) {
      wide.addListener(sync);
      reduced.addListener(sync);
    }
  }

  /* --------------------------------------------------------------- open/den
     The signature switch. Both states stay in the DOM and are grid-stacked into
     one cell, so the block never changes height and the toggle reads as one bed
     changing rather than two beds swapping.

     The hood does not detach. It unzips and folds back onto the rim. */
  function swap() {
    var groups = document.querySelectorAll('[data-rn-swap]');

    Array.prototype.forEach.call(groups, function (group) {
      var buttons = group.querySelectorAll('[data-rn-swap-to]');
      var states = group.querySelectorAll('[data-rn-swap-state]');
      if (!buttons.length || !states.length) return;

      function show(name) {
        Array.prototype.forEach.call(states, function (state) {
          var on = state.getAttribute('data-rn-swap-state') === name;
          state.classList.toggle('rn-swap-state-active', on);
          /* aria-hidden rather than display:none — the state has to stay in flow
             to hold the block's height. */
          state.setAttribute('aria-hidden', on ? 'false' : 'true');
        });
        Array.prototype.forEach.call(buttons, function (button) {
          var on = button.getAttribute('data-rn-swap-to') === name;
          button.classList.toggle('rn-toggle-btn-active', on);
          button.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      }

      Array.prototype.forEach.call(buttons, function (button) {
        // Buttons fire on click; the size finder's chips are radio inputs and
        // fire on change. Binding both keeps one implementation for both, and
        // the radios keep working with the script blocked because the browser
        // handles selection itself.
        var evt = button.tagName === 'INPUT' ? 'change' : 'click';
        button.addEventListener(evt, function () {
          show(button.getAttribute('data-rn-swap-to'));
        });
      });

      show(group.getAttribute('data-rn-swap') || buttons[0].getAttribute('data-rn-swap-to'));
    });
  }

  /* ------------------------------------------------------------ size finder
     Chips are native radios, so the browser owns selection and the correct
     variant submits with no script at all. This only moves the result card,
     whose starting state is rendered server-side. */
  function sizeFinder() {
    var finders = document.querySelectorAll('[data-rn-finder]');

    Array.prototype.forEach.call(finders, function (finder) {
      var inputs = finder.querySelectorAll('[data-rn-size]');
      var results = finder.querySelectorAll('[data-rn-size-result]');
      if (!inputs.length || !results.length) return;

      function show(key) {
        Array.prototype.forEach.call(results, function (r) {
          var on = r.getAttribute('data-rn-size-result') === key;
          r.classList.toggle('rn-finder-result-active', on);
          r.setAttribute('aria-hidden', on ? 'false' : 'true');
        });
        Array.prototype.forEach.call(inputs, function (i) {
          var chip = i.closest('.rn-chip');
          if (chip) chip.classList.toggle('rn-chip-selected', i.getAttribute('data-rn-size') === key);
        });
      }

      Array.prototype.forEach.call(inputs, function (i) {
        i.addEventListener('change', function () {
          if (i.checked) show(i.getAttribute('data-rn-size'));
        });
      });
    });
  }

  /* ---------------------------------------------------------------- gallery
     Thumbnails swap the main frame's src. The main image is server-rendered as
     the product's featured media, so with the script blocked the gallery shows
     the right picture and the thumbnails simply do nothing — a wrong picture
     would be worse than an inert one. */
  function gallery() {
    var wraps = document.querySelectorAll('[data-rn-gallery]');

    Array.prototype.forEach.call(wraps, function (wrap) {
      var main = wrap.querySelector('[data-rn-gallery-main]');
      var thumbs = wrap.querySelectorAll('[data-rn-thumb]');
      if (!main || !thumbs.length) return;

      Array.prototype.forEach.call(thumbs, function (thumb) {
        thumb.addEventListener('click', function () {
          main.src = thumb.getAttribute('data-rn-thumb');
          var img = thumb.querySelector('img');
          main.alt = thumb.getAttribute('aria-label') || (img ? img.alt : '');
          Array.prototype.forEach.call(thumbs, function (t) {
            t.classList.toggle('rn-thumb-selected', t === thumb);
          });
        });
      });
    });
  }

  /* -------------------------------------------------------- quantity stepper
     The number field is the source of truth; the buttons only step it. With the
     script blocked the field still types and still submits. */
  function quantity() {
    var steppers = document.querySelectorAll('[data-rn-qty]');

    Array.prototype.forEach.call(steppers, function (wrap) {
      var input = wrap.querySelector('.rn-qty-input');
      if (!input) return;

      Array.prototype.forEach.call(wrap.querySelectorAll('[data-rn-qty-step]'), function (btn) {
        btn.addEventListener('click', function () {
          var step = parseInt(btn.getAttribute('data-rn-qty-step'), 10) || 0;
          var min = parseInt(input.getAttribute('min'), 10);
          if (isNaN(min)) min = 1;
          var next = (parseInt(input.value, 10) || min) + step;
          if (next < min) next = min;
          input.value = next;
          // Shopify's cart scripts listen for change, not for the click.
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* --------------------------------------------------------------- cart page
     The cart is server-rendered on every change: the quantity form POSTs to
     /cart/change and the browser navigates, so the line total, the subtotal and
     the count in the header all come back from the same response and cannot
     drift apart. This function does exactly two things on top of that markup.

     1. It hides the update control. The stepper buttons are type="button" and
        only move the field — that is the house rule, because the field has to
        keep typing and submitting with the script gone. Which means that with
        the script gone the stepper needs something to submit it, and that is the
        update button. It is rendered by default and removed HERE, so a visitor
        with no JavaScript keeps a working control instead of a dead one.

     2. It submits the form when the field changes. quantity() already dispatches
        a change event after stepping, so + and - post on the first click.

     Guarded by data-rn-cart-bound because init() re-runs on
     shopify:section:load, and a second listener would post the same line twice. */
  function cartPage() {
    var forms = document.querySelectorAll('[data-rn-cart-line]');

    Array.prototype.forEach.call(forms, function (form) {
      if (form.hasAttribute('data-rn-cart-bound')) return;
      form.setAttribute('data-rn-cart-bound', '');

      var update = form.querySelector('button[type="submit"]');
      if (update) update.hidden = true;

      var input = form.querySelector('.rn-qty-input');
      if (!input) return;

      input.addEventListener('change', function () {
        // A blank or negative field is not an instruction. Zero is — it removes
        // the line, which is what /cart/change does with quantity=0.
        var n = parseInt(input.value, 10);
        if (isNaN(n) || n < 0) { input.value = input.defaultValue; return; }
        if (String(n) === input.defaultValue) return;
        input.value = n;
        if (form.requestSubmit) { form.requestSubmit(); } else { form.submit(); }
      });
    });
  }

  /* ----------------------------------------------------------- sticky cart
     Revealed once the hero leaves the viewport, not on a scroll offset — the
     hero's height is a layout decision and this should not have an opinion
     about it. */
  function stickyCart() {
    var bar = document.querySelector('.rn-sticky-atc');
    var anchor = document.querySelector('[data-rn-sticky-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;

    new IntersectionObserver(function (entries) {
      bar.classList.toggle('rn-sticky-atc-visible', !entries[0].isIntersecting);
    }).observe(anchor);
  }

  /* ------------------------------------------------------------ mobile drawer
     Below 1024px .rn-nav is display:none and there was no other way to reach
     the menu at all. This opens the panel that carries the same blocks.

     Everything here is guarded by data-rn-drawer-bound, because init() re-runs
     on shopify:section:load — the theme editor rips a section out and puts it
     back on every keystroke, and an unguarded addEventListener would stack a
     new open handler on the toggle each time.

     Focus is trapped for as long as the panel is open. That is not decoration:
     an aria-modal dialog whose Tab key walks out into the page behind the
     scrim lies to a screen reader about what is reachable. */
  function drawer() {
    var panel = document.querySelector('[data-rn-drawer]');
    if (!panel || panel.hasAttribute('data-rn-drawer-bound')) return;
    panel.setAttribute('data-rn-drawer-bound', '');

    var toggle = document.querySelector('[data-rn-drawer-open]');
    if (!toggle) return;

    var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), ' +
                    'select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    var opener = null;

    function items() {
      return Array.prototype.filter.call(
        panel.querySelectorAll(FOCUSABLE),
        function (el) { return el.offsetParent !== null || el === document.activeElement; }
      );
    }

    function open() {
      opener = document.activeElement;
      panel.hidden = false;
      // Two frames. The panel has to be laid out at translateX(100%) before the
      // class flips it to 0, or the browser coalesces both into one style
      // resolution and the drawer appears instead of sliding.
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { panel.classList.add('rn-drawer-open'); });
      });
      document.documentElement.classList.add('rn-noscroll');
      toggle.setAttribute('aria-expanded', 'true');
      var first = panel.querySelector('[data-rn-drawer-close]:not(.rn-drawer-scrim)') || items()[0];
      if (first) first.focus();
      document.addEventListener('keydown', onKey, true);
    }

    function close() {
      panel.classList.remove('rn-drawer-open');
      document.documentElement.classList.remove('rn-noscroll');
      toggle.setAttribute('aria-expanded', 'false');
      document.removeEventListener('keydown', onKey, true);

      // Wait out the slide before hiding, so the panel does not vanish
      // mid-transition. Under reduced motion the duration token is 1ms, so this
      // is effectively immediate and still correct.
      var ms = reduced.matches ? 0 : 400;
      window.setTimeout(function () {
        if (!panel.classList.contains('rn-drawer-open')) panel.hidden = true;
      }, ms);

      if (opener && opener.focus) opener.focus();
      opener = null;
    }

    function onKey(e) {
      if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); close(); return; }
      if (e.key !== 'Tab') return;

      var list = items();
      if (!list.length) return;
      var first = list[0];
      var last = list[list.length - 1];

      // The trap. Shift+Tab off the first item wraps to the last, and Tab off
      // the last wraps to the first. Anything focused outside the panel — which
      // is what happens on the very first Tab after a click — is pulled back in.
      if (!panel.contains(document.activeElement)) { e.preventDefault(); first.focus(); return; }
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    toggle.addEventListener('click', open);

    Array.prototype.forEach.call(panel.querySelectorAll('[data-rn-drawer-close]'), function (el) {
      el.addEventListener('click', close);
    });

    // A link inside the panel navigates, but a same-page anchor does not — the
    // browser just moves the scroll position and the drawer would stay open on
    // top of the section it jumped to.
    Array.prototype.forEach.call(panel.querySelectorAll('.rn-drawer-nav a, .rn-drawer-foot a'), function (a) {
      a.addEventListener('click', function () { close(); });
    });

    // Crossing the breakpoint with the panel open leaves a scrim over a page
    // that now shows its inline nav. Close it rather than letting both exist.
    var wide = window.matchMedia('(min-width: 1024px)');
    function onWide() { if (wide.matches && !panel.hidden) close(); }
    if (wide.addEventListener) wide.addEventListener('change', onWide);
    else if (wide.addListener) wide.addListener(onWide);
  }

  /* --------------------------------------------------------------- reveal */
  function reveal() {
    var items = document.querySelectorAll('.rn-reveal');
    if (!items.length) return;

    if (reduced.matches || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(items, function (i) { i.classList.add('rn-reveal-in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('rn-reveal-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -10% 0px' });

    Array.prototype.forEach.call(items, function (i) { io.observe(i); });
  }

  /* --------------------------------------------------------- variant picker
     Two independent rows of chips -> one variant id. The rows are the product's
     options; which options those are is decided in Liquid, so nothing here is
     named "size" or "color" and a third row needs no change to this function.

     THE HIDDEN FIELD IS ENABLED HERE, first thing, and that is load-bearing.
     It ships disabled so that with this file blocked it is not submitted and the
     <noscript> radios carry the id instead. Enabling it is what hands this
     function the wheel; if it never runs, the fallback is already correct.

     Availability is recomputed per row on every change, and narrowed by the
     OTHER rows: Brown may be buyable in Small and not in Large, which is not
     something the server can render because it depends on a choice not yet made.
     Dead values are disabled and struck through, never removed. */
  /* ------------------------------------------------------------------- money
     Reading a formatted amount back out of a string, so the save pill can be
     the arithmetic of the two figures printed beside it.

     WHY NOT CENTS. The variant JSON carries prices already run through Liquid's
     `money` filter, because the store's currency and its format string are
     Shopify's to decide and a second formatter here is a second thing to get
     wrong. That decision stands; this reads the formatted string rather than
     replacing it, and hands back a saving wearing the SAME symbol, spacing and
     suffix the compare-at wore. Anything it cannot parse returns empty, and an
     empty saving hides the pill — a discount is not a thing to guess at. */
  function parseMoney(s) {
    if (!s) return null;
    var t = String(s).replace(/&[^;]+;/g, ' ');
    var m = t.match(/\d[\d.,\s\u00A0\u202F]*/);
    if (!m) return null;
    /* The class above is greedy and will swallow the space in "79,95 kr".
       Trimmed back to the last digit so the suffix keeps its own spacing when
       the amount is written back into the string. */
    var raw = m[0].replace(/[^\d]+$/, '');
    var digits = raw.replace(/[\s\u00A0\u202F]/g, '');
    /* The decimal separator is whichever of . or , comes last AND is followed
       by exactly two digits. "1.234" is a thousands group; "12.34" is not. */
    var last = Math.max(digits.lastIndexOf('.'), digits.lastIndexOf(','));
    var dec = (last > -1 && digits.length - last - 1 === 2) ? digits.charAt(last) : null;
    var whole = dec ? digits.slice(0, last) : digits;
    var frac  = dec ? digits.slice(last + 1) : '';
    var n = parseInt(whole.replace(/[.,]/g, ''), 10);
    if (isNaN(n)) return null;
    return { cents: n * 100 + (frac ? parseInt(frac, 10) : 0),
             raw: raw, start: m.index, dec: dec };
  }

  /* compare-at minus price, formatted like the compare-at was. Trailing zeros
     are dropped to match money_without_trailing_zeros on the server, so the
     figure does not change shape when the script takes over from Liquid. */
  function moneyDiff(compareStr, priceStr) {
    var c = parseMoney(compareStr), p = parseMoney(priceStr);
    if (!c || !p) return '';
    var d = c.cents - p.cents;
    if (d <= 0) return '';
    var dec = c.dec || '.';
    var group = dec === ',' ? '.' : ',';
    var whole = String(Math.floor(d / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, group);
    var frac = d % 100;
    var num = frac ? whole + dec + (frac < 10 ? '0' + frac : String(frac)) : whole;
    return String(compareStr).slice(0, c.start) + num
         + String(compareStr).slice(c.start + c.raw.length);
  }

  /* Write a button's label without taking its other children with it.

     btn.textContent = 'Sold out' replaces EVERY child the button has, which is
     fine for a button whose only content is its label and destructive for one
     carrying a price. rn-button wraps the label in [data-rn-btn-label] for
     exactly this; the fallback keeps the old behaviour for any button rendered
     by something that does not. */
  function setBtnLabel(btn, text) {
    if (!btn || text == null) return;
    var lbl = btn.querySelector('[data-rn-btn-label]');
    if (lbl) lbl.textContent = text;
    else btn.textContent = text;
  }

  function variantPicker() {
    var roots = document.querySelectorAll('[data-rn-variants]');

    Array.prototype.forEach.call(roots, function (root) {
      if (root.hasAttribute('data-rn-variants-bound')) return;

      var dataEl = root.querySelector('[data-rn-variant-data]');
      var hidden = root.querySelector('[data-rn-variant-id]');
      if (!dataEl) return;

      var data;
      try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
      if (!data || !data.vars || !data.vars.length) return;

      root.setAttribute('data-rn-variants-bound', '');
      if (hidden) hidden.disabled = false;

      var radios = root.querySelectorAll('[data-rn-opt]');
      if (!radios.length) return;

      /* SCOPED, not document-wide. On the product template this section and
         the size finder are both on the page and both carry a
         [data-rn-variant-submit]; a document-level lookup would find whichever
         came first in the source and drive the wrong button. The form is the
         picker's own, and the price lives with the rail outside it, so the
         section element is the narrowest thing that holds both. */
      var form     = root.closest ? root.closest('form') : null;
      var scope    = root.closest ? root.closest('section') : null;
      if (!scope) scope = document;
      var priceEl  = scope.querySelector('[data-rn-variant-price]');
      var submit   = form ? form.querySelector('[data-rn-variant-submit]') : null;
      var atcLabel = root.getAttribute('data-rn-atc-label') || 'Add to cart';
      var soldLabel= root.getAttribute('data-rn-sold-label') || 'Sold out';
      /* The heading readouts — "Color: Grey", "Size: Large · up to 38 lbs".
         Scoped to the picker's own root, because the size finder further down
         the product template renders option rows too. */
      var readouts = root.querySelectorAll('[data-rn-optreadout]');

      /* THE GALLERY, SCOPED THE SAME WAY THE PRICE IS.
         The picker lives in the buy rail and the gallery is its sibling inside
         the same section, so `scope` already holds both — the size finder is a
         different section and carries no gallery, which is why this cannot pick
         up the wrong one. */
      var galleryMain  = scope.querySelector('[data-rn-gallery-main]');
      var galleryThumbs= scope.querySelectorAll('[data-rn-thumb]');
      /* What the gallery showed before any variant was chosen. It is the
         fallback for a variant with no image of its own, and it is captured
         once here rather than read back later — by then the src may already be
         a previous variant's picture. */
      var galleryStart = galleryMain ? { src: galleryMain.getAttribute('src'), alt: galleryMain.getAttribute('alt') || '' } : null;

      /* Point the gallery at a variant's image, or put it back.

         SRC IS COMPARED BEFORE IT IS WRITTEN. Assigning the same URL still
         restarts a decode and makes the picture blink on every click of a size
         chip, which changes the variant but not the colour, and therefore not
         the image. */
      /* ------------------------------------------- colour filter, thumb strip
         Which option index holds the colourway: the one whose NAME matches the
         section's swatch setting. Matching on the name rather than on a fixed
         index is what survives someone reordering the product's options in the
         admin, which is a two-click change with no warning attached to it. */
      var colorName = (root.getAttribute('data-rn-color-option') || '').toLowerCase();
      var colorIdx  = -1;
      for (var ci = 0; ci < data.opts.length; ci++) {
        if (String(data.opts[ci].name).toLowerCase() === colorName) { colorIdx = ci; break; }
      }

      /* Show the thumbnails tagged with this colourway, plus the ones tagged
         #Both. The tag is parsed off the media's alt text by Liquid and lands
         in data-rn-thumb-color; #Excluded never renders at all.

         AN UNTAGGED THUMBNAIL IS ALWAYS SHOWN, and the whole strip comes back
         if a filter would empty it. A strip that disappears because somebody
         uploaded a picture without an alt is a worse failure than one that
         filters nothing — the reader loses the gallery and is told nothing. */
      function filterThumbs(color) {
        if (colorIdx < 0 || !galleryThumbs.length) return;
        var want = String(color || '').toLowerCase();
        var visible = [];
        Array.prototype.forEach.call(galleryThumbs, function (t) {
          var tag = (t.getAttribute('data-rn-thumb-color') || '').toLowerCase();
          var show = tag === 'both' || tag === want;
          t.hidden = !show;
          if (show) visible.push(t);
        });
        if (!visible.length) {
          Array.prototype.forEach.call(galleryThumbs, function (t) {
            t.hidden = false; visible.push(t);
          });
        }

        /* showVariantImage() has already run and stays in charge of the main
           frame. This only covers the case it cannot: a variant with no image
           of its own leaves the gallery on the previous picture, which after a
           colour change is the other colourway. Then, and only then, the first
           visible thumbnail wins. */
        if (!galleryMain) return;
        var cur = galleryMain.getAttribute('src');
        for (var i = 0; i < visible.length; i++) {
          if (visible[i].getAttribute('data-rn-thumb') === cur) return;
        }
        galleryMain.setAttribute('src', visible[0].getAttribute('data-rn-thumb'));
        galleryMain.setAttribute('alt', visible[0].getAttribute('aria-label') || '');
        Array.prototype.forEach.call(galleryThumbs, function (t) {
          t.classList.toggle('rn-thumb-selected', t === visible[0]);
        });
      }

      function showVariantImage(v) {
        if (!galleryMain) return;
        var want = (v && v.i) ? v.i : (galleryStart ? galleryStart.src : null);
        var alt  = (v && v.i) ? (v.ia || '') : (galleryStart ? galleryStart.alt : '');
        if (!want || galleryMain.getAttribute('src') === want) return;
        galleryMain.setAttribute('src', want);
        galleryMain.setAttribute('alt', alt);
        /* Keep the thumb strip honest: a thumbnail ring still sitting on the
           previous picture says the gallery is showing something it is not.
           data-rn-thumb holds the same 1400px URL the island does, so the two
           compare directly. */
        Array.prototype.forEach.call(galleryThumbs, function (t) {
          t.classList.toggle('rn-thumb-selected', t.getAttribute('data-rn-thumb') === want);
        });
      }

      /* The values currently checked, one per option index. */
      function chosen() {
        var out = [];
        Array.prototype.forEach.call(radios, function (r) {
          if (r.checked) out[parseInt(r.getAttribute('data-rn-opt'), 10)] = r.value;
        });
        return out;
      }

      /* The variant matching every chosen value. Undefined is a real answer:
         a combination that does not exist is not the same as one that is out
         of stock, and the two must not be collapsed. */
      function match(vals) {
        for (var i = 0; i < data.vars.length; i++) {
          var v = data.vars[i], ok = true;
          for (var j = 0; j < vals.length; j++) {
            if (vals[j] !== undefined && v.o[j] !== vals[j]) { ok = false; break; }
          }
          if (ok) return v;
        }
        return null;
      }

      /* Is `val` at option `idx` buyable, holding every other row as it is? */
      function live(idx, val) {
        var vals = chosen().slice();
        vals[idx] = val;
        for (var i = 0; i < data.vars.length; i++) {
          var v = data.vars[i], ok = true;
          for (var j = 0; j < vals.length; j++) {
            if (vals[j] !== undefined && v.o[j] !== vals[j]) { ok = false; break; }
          }
          if (ok && v.a) return true;
        }
        return false;
      }

      function sync() {
        var vals = chosen();
        var v = match(vals);

        Array.prototype.forEach.call(radios, function (r) {
          var idx  = parseInt(r.getAttribute('data-rn-opt'), 10);
          var chip = r.parentNode;
          var ok   = live(idx, r.value);
          r.disabled = !ok;
          if (chip && chip.classList) {
            chip.classList.toggle('rn-chip-disabled', !ok);
            chip.classList.toggle('rn-chip-selected', r.checked);
          }
          /* The heading's readout. The STRING comes off the radio, composed by
             Liquid from the product's own size table — this only copies it. A
             weight ceiling assembled in JS would be a second place where a size
             gets a number, and the two would eventually disagree. */
          if (r.checked) {
            Array.prototype.forEach.call(readouts, function (out) {
              if (parseInt(out.getAttribute('data-rn-optreadout'), 10) !== idx) return;
              out.textContent = r.getAttribute('data-rn-readout') || r.value;
            });
          }
        });

        if (hidden) hidden.value = v ? v.id : '';

        showVariantImage(v);
        if (colorIdx >= 0) filterThumbs(vals[colorIdx]);

        if (priceEl && v) {
          /* Write into the marker's own span so the dotted underline and the
             data-token survive. Falls back to the paragraph when the figure is
             not wearing a marker. */
          /* [data-rn-price-now] first: it is the figure's own span and exists
             whether or not the figure is marked. .rn-unconfirmed is kept as a
             fallback for any other section still rendering the older shape, and
             priceEl last — which is a last resort, not a target, because the
             paragraph also holds the compare-at and the save pill. */
          var mark = priceEl.querySelector('[data-rn-price-now]') ||
                     priceEl.querySelector('.rn-unconfirmed') || priceEl;
          mark.textContent = v.p;
          var was = priceEl.querySelector('[data-rn-variant-compare]');
          if (was) {
            if (v.c) { was.textContent = v.c; was.hidden = false; }
            else     { was.textContent = '';  was.hidden = true;  }
          }
          /* The save pill. Arithmetic on the two figures beside it, so it can
             never contradict them, and gone entirely when there is nothing to
             save. Money is parsed back out of the strings Liquid already
             formatted rather than recomputed from cents: the store's currency
             and its format string are Shopify's to decide, and a second
             formatter here is a second thing to get wrong. If either string
             does not parse, the pill hides instead of guessing. */
          var save = priceEl.querySelector('[data-rn-variant-save]');
          if (save) {
            var word = save.getAttribute('data-rn-save-word') || '';
            var diff = moneyDiff(v.c, v.p);
            if (v.c && diff) { save.textContent = (word ? word + ' ' : '') + diff; save.hidden = false; }
            else             { save.textContent = ''; save.hidden = true; }
          }
        }

        if (submit) {
          var btn = submit.querySelector('button');
          if (btn) {
            var buyable = !!(v && v.a);
            btn.disabled = !buyable;
            btn.classList.toggle('rn-btn-disabled', !buyable);
            setBtnLabel(btn, buyable ? atcLabel : soldLabel);
            /* The price inside the control is the same figure as the price row,
               so it is written into the marker's own span for the same reason. */
            var atcPrice = btn.querySelector('[data-rn-atc-price]');
            if (atcPrice) {
              if (v && v.p) {
                var atcMark = atcPrice.querySelector('.rn-unconfirmed') || atcPrice;
                atcMark.textContent = v.p;
                atcPrice.hidden = false;
              } else {
                atcPrice.hidden = true;
              }
            }
          }
        }
      }

      Array.prototype.forEach.call(radios, function (r) {
        r.addEventListener('change', sync);
      });
      sync();
    });
  }

  /* ------------------------------------------------- size finder, by variant
     The finder's sizes are its own blocks and stay as they are; what moves here
     is the COLOUR. Every size card holds its own add-to-cart form with a hidden
     variant id, resolved server-side against the colour that loaded. Changing
     colour re-points all four at once, so the card a visitor is looking at and
     the three behind it never disagree.

     Keyed on the size VALUE the card carries, never on card order — block order
     is a merchant setting and sorting the finder by weight would otherwise post
     the wrong bed. */
  function sizeFinderVariants() {
    var roots = document.querySelectorAll('[data-rn-sizevariants]');

    Array.prototype.forEach.call(roots, function (root) {
      if (root.hasAttribute('data-rn-sizevariants-bound')) return;

      var dataEl = root.querySelector('[data-rn-variant-data]');
      if (!dataEl) return;
      var data;
      try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
      if (!data || !data.vars || !data.vars.length) return;

      var radios = root.querySelectorAll('[data-rn-opt]');
      var fields = root.querySelectorAll('[data-rn-size-variant]');
      if (!fields.length) return;

      root.setAttribute('data-rn-sizevariants-bound', '');

      /* Which option index holds the sizes: the one whose values include the
         size a card names. Same rule as the Liquid, worked out the same way, so
         the two cannot disagree about which row is which. */
      var sizeIdx = -1;
      var probe = (fields[0].getAttribute('data-rn-size-value') || '').toLowerCase();
      for (var i = 0; i < data.opts.length && sizeIdx < 0; i++) {
        for (var j = 0; j < data.opts[i].values.length; j++) {
          if (String(data.opts[i].values[j]).toLowerCase() === probe) { sizeIdx = i; break; }
        }
      }
      if (sizeIdx < 0) return;

      function chosen() {
        var out = [];
        Array.prototype.forEach.call(radios, function (r) {
          if (r.checked) out[parseInt(r.getAttribute('data-rn-opt'), 10)] = r.value;
        });
        return out;
      }

      function sync() {
        var vals = chosen();

        Array.prototype.forEach.call(radios, function (r) {
          var chip = r.parentNode;
          if (chip && chip.classList) chip.classList.toggle('rn-chip-selected', r.checked);
        });

        Array.prototype.forEach.call(fields, function (field) {
          var size = (field.getAttribute('data-rn-size-value') || '').toLowerCase();
          var found = null;
          for (var i = 0; i < data.vars.length; i++) {
            var v = data.vars[i], ok = String(v.o[sizeIdx]).toLowerCase() === size;
            if (ok) {
              for (var j = 0; j < vals.length; j++) {
                if (j !== sizeIdx && vals[j] !== undefined && v.o[j] !== vals[j]) { ok = false; break; }
              }
            }
            if (ok) { found = v; break; }
          }
          if (!found) return;

          field.value = found.id;

          var wrap = field.form ? field.form.querySelector('[data-rn-variant-submit]') : null;
          if (!wrap) return;
          var btn = wrap.querySelector('button');
          if (!btn) return;
          btn.disabled = !found.a;
          btn.classList.toggle('rn-btn-disabled', !found.a);
          setBtnLabel(btn, found.a
            ? (wrap.getAttribute('data-rn-atc-label') || null)
            : (wrap.getAttribute('data-rn-sold-label') || null));
        });
      }

      Array.prototype.forEach.call(radios, function (r) {
        r.addEventListener('change', sync);
      });
      sync();
    });
  }

  /* ------------------------------------------------------------ cart drawer
     Slides in from the right after add-to-cart. The cart PAGE is still the
     fallback: with this file blocked every add-to-cart form posts normally, the
     browser lands on /cart, and every control there is a real form post.

     NOTHING HERE FORMATS MONEY OR COUNTS ANYTHING. After each mutation the
     server re-renders the drawer body and the header through the Section
     Rendering API and the returned markup is swapped in. That is the whole
     answer to the objection written on the cart page — a drawer is only a
     second copy if it renders itself, and this one never does.

     Only the body region is replaced, never the panel: replacing the dialog a
     person is looking at would drop the focus trap and the open state with it. */
  function cartDrawer() {
    var root = document.querySelector('[data-rn-cartdrawer]');
    if (!root || root.hasAttribute('data-rn-cartdrawer-bound')) return;
    root.setAttribute('data-rn-cartdrawer-bound', '');

    var panel  = root.querySelector('.rn-cartdrawer-panel');
    var body   = root.querySelector('[data-rn-cartdrawer-content]');
    if (!panel || !body) return;

    var SECTION_ID = 'rn-cart-drawer';   // a static section: its ID is its filename
    var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), ' +
                    'select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    var opener = null;
    var busy = false;

    function items() {
      return Array.prototype.filter.call(panel.querySelectorAll(FOCUSABLE), function (el) {
        return el.offsetParent !== null || el === document.activeElement;
      });
    }

    function open() {
      if (!root.hidden) return;
      opener = document.activeElement;
      root.hidden = false;
      /* Two frames: the panel has to be laid out at translateX(100%) before the
         class flips it to 0, or both resolve in one pass and it appears rather
         than slides. Same reason as the nav drawer. */
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { root.classList.add('rn-cartdrawer-open'); });
      });
      document.documentElement.classList.add('rn-noscroll');
      var first = panel.querySelector('[data-rn-cartdrawer-close]') || items()[0];
      if (first) first.focus();
      document.addEventListener('keydown', onKey, true);
    }

    function close() {
      root.classList.remove('rn-cartdrawer-open');
      document.documentElement.classList.remove('rn-noscroll');
      document.removeEventListener('keydown', onKey, true);
      var ms = reduced.matches ? 0 : 400;
      window.setTimeout(function () {
        if (!root.classList.contains('rn-cartdrawer-open')) root.hidden = true;
      }, ms);
      if (opener && opener.focus) opener.focus();
      opener = null;
    }

    function onKey(e) {
      if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); close(); return; }
      if (e.key !== 'Tab') return;
      var list = items();
      if (!list.length) return;
      var first = list[0], last = list[list.length - 1];
      if (!panel.contains(document.activeElement)) { e.preventDefault(); first.focus(); return; }
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    /* Swap in what the server just rendered. The header's cart control is taken
       from the freshly rendered header rather than having its number written by
       hand — the accessible name is a PLURAL out of the locale file ("1 item" /
       "2 items"), and a plural rebuilt in JavaScript is a translation bug in
       every language the shop later adds. */
    function apply(sections) {
      if (!sections) return;

      var drawerHtml = sections[SECTION_ID];
      if (drawerHtml) {
        var doc = new DOMParser().parseFromString(drawerHtml, 'text/html');
        var fresh = doc.querySelector('[data-rn-cartdrawer-content]');
        if (fresh) body.innerHTML = fresh.innerHTML;

        var freshCount = doc.querySelector('[data-rn-cartdrawer-countline]');
        var liveCount  = root.querySelector('[data-rn-cartdrawer-countline]');
        if (freshCount && liveCount) liveCount.textContent = freshCount.textContent;

        var freshRoot = doc.querySelector('[data-rn-cartdrawer]');
        var n = freshRoot ? parseInt(freshRoot.getAttribute('data-rn-cart-count'), 10) : NaN;
        if (!isNaN(n)) {
          root.setAttribute('data-rn-cart-count', n);
          syncHeaderCart(n, freshCount ? freshCount.textContent.trim() : '');
        }
      }

    }

    /* The header's cart control, updated from what the drawer just rendered.
       The header itself is in a section group and so has no addressable ID —
       it cannot be re-rendered the way the drawer is. What it needs is only two
       things, and both come from the server rather than from arithmetic here:
       the count, and the PLURAL that names it. The plural is the reason this is
       not simply `badge.textContent = n`: "1 item" / "2 items" is a locale
       string, and a plural rebuilt in JavaScript is a translation bug in every
       language the shop later adds. */
    function syncHeaderCart(n, plural) {
      Array.prototype.forEach.call(document.querySelectorAll('.rn-cart'), function (a) {
        var badge = a.querySelector('.rn-cart-count');
        if (n > 0 && !badge) {
          badge = document.createElement('span');
          badge.className = 'rn-cart-count';
          badge.setAttribute('aria-hidden', 'true');
          a.appendChild(badge);
        }
        if (badge) {
          if (n > 0) badge.textContent = n;
          else badge.parentNode.removeChild(badge);   // no badge at zero, same as the Liquid
        }
        if (plural) {
          /* The accessible name is "<cart label>: <plural>". Keep the label the
             merchant set, replace only the part that changed. */
          var current = a.getAttribute('aria-label') || '';
          var cut = current.indexOf(':');
          a.setAttribute('aria-label', cut > -1 ? current.slice(0, cut + 1) + ' ' + plural : plural);
        }
      });
    }

    function post(url, payload, isForm) {
      busy = true;
      var opts = { method: 'POST', headers: { 'Accept': 'application/json' } };
      if (isForm) {
        opts.body = payload;
      } else {
        opts.headers['Content-Type'] = 'application/json';
        opts.body = JSON.stringify(payload);
      }
      return fetch(url, opts)
        .then(function (r) { return r.json().then(function (j) {
          if (!r.ok) throw j;
          return j;
        }); })
        .then(function (json) { apply(json.sections); busy = false; return json; })
        .catch(function (err) { busy = false; throw err; });
    }

    function change(line, quantity) {
      if (busy) return;
      post(routesCartChange(), { line: line, quantity: quantity, sections: SECTION_ID })
        .catch(function () { window.location.href = cartUrl(); });
    }

    /* The routes are read off the markup rather than hardcoded: a shop on a
       locale or market prefix serves /fr/cart/change.js, and a literal path
       would silently 404 into a full page reload on every quantity change. */
    function cartUrl() {
      var a = document.querySelector('.rn-cart');
      return (a && a.getAttribute('href')) || '/cart';
    }
    function routesCartChange() { return cartUrl().replace(/\/cart\/?$/, '/cart') + '/change.js'; }
    function routesCartAdd()    { return cartUrl().replace(/\/cart\/?$/, '/cart') + '/add.js'; }

    /* Delegated, so the handlers survive every innerHTML swap of the body.
       Binding per line would mean rebinding after each update, and one missed
       rebind is a stepper that silently stops working. */
    body.addEventListener('click', function (e) {
      var remove = e.target.closest ? e.target.closest('[data-rn-drawer-remove]') : null;
      if (remove) {
        e.preventDefault();
        change(parseInt(remove.getAttribute('data-rn-drawer-remove'), 10), 0);
        return;
      }
      var step = e.target.closest ? e.target.closest('[data-rn-drawer-step]') : null;
      if (step) {
        e.preventDefault();
        var wrap = step.closest('[data-rn-drawer-qty]');
        var input = wrap && wrap.querySelector('[data-rn-drawer-qtyinput]');
        if (!wrap || !input) return;
        var next = (parseInt(input.value, 10) || 0) + (parseInt(step.getAttribute('data-rn-drawer-step'), 10) || 0);
        if (next < 0) next = 0;
        input.value = next;
        change(parseInt(wrap.getAttribute('data-rn-line'), 10), next);
      }
    });

    body.addEventListener('change', function (e) {
      var input = e.target;
      if (!input.hasAttribute || !input.hasAttribute('data-rn-drawer-qtyinput')) return;
      var wrap = input.closest('[data-rn-drawer-qty]');
      if (!wrap) return;
      var n = parseInt(input.value, 10);
      if (isNaN(n) || n < 0) n = 0;
      change(parseInt(wrap.getAttribute('data-rn-line'), 10), n);
    });

    Array.prototype.forEach.call(root.querySelectorAll('[data-rn-cartdrawer-close]'), function (el) {
      el.addEventListener('click', close);
    });

    /* The header cart stops navigating and opens the drawer instead. The href
       stays exactly as it was, so the cart page is still one middle-click away
       and still the destination with this file blocked.

       No fetch here: the drawer body was rendered by Liquid with this page and
       already holds the cart as the server sees it. Re-requesting it on open
       would put a network round trip in front of a panel that is already
       correct, and show an empty drawer for the length of it. */
    Array.prototype.forEach.call(document.querySelectorAll('.rn-cart'), function (a) {
      a.addEventListener('click', function (e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
        e.preventDefault();
        open();
      });
    });

    /* Add to cart, from anywhere: the buy rail, the size finder, anything added
       later. Matched on the ACTION rather than on a per-section hook, so a new
       section that posts to /cart/add is picked up with no change here. */
    if (root.hasAttribute('data-rn-open-on-add')) {
      document.addEventListener('submit', function (e) {
        var form = e.target;
        if (!form || !form.getAttribute) return;
        var action = form.getAttribute('action') || '';
        if (action.indexOf('/cart/add') === -1) return;

        e.preventDefault();
        var fd = new FormData(form);
        fd.append('sections', SECTION_ID);
        post(routesCartAdd(), fd, true)
          .then(function () { open(); })
          .catch(function () { form.submit(); });   // let the browser do it the old way
      });
    }
  }

  function init() {
    header();
    announcement();
    swap();
    sizeFinder();
    variantPicker();
    sizeFinderVariants();
    gallery();
    quantity();
    cartPage();
    stickyCart();
    drawer();
    cartDrawer();
    reveal();
  }

  // The theme editor tears a section out of the DOM and re-inserts it on every
  // change, which drops every listener bound above. Without this, a merchant
  // editing the zip switch sees the toggle stop working and has no way to know
  // that reloading fixes it.
  document.addEventListener('shopify:section:load', init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
